module.exports = __webpack_public_path__ + "img/reserved.2839f50a.png";